/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2022-07-18 14:42:08
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-03-10 10:11:28
 * @FilePath: \ioc_base\src\common\utils\bus.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 *@Description:业务工具库
 */
import { Cache } from "$utils";

const BUS = {
  imgPath(fileCode) {
    return fileCode
      ? "/common/file/downLoadFileStream.json?fileCode=" + fileCode
      : "";
  },
  imgPathVcm(fileId) {
    let token = Cache.get("access_token");
    let fileIds = "";
    if (fileId && fileId.length) {
      fileIds = fileId.replace(/\#/g, "%23"); // eslint-disable-line
      fileIds = fileIds.replace(/\@/g, "%40"); // eslint-disable-line
    }
    return (
      "/bas/safeEvent/getPictureStream.json?fileId=" +
      fileIds +
      "&imageType=1&ticket=" +
      token +
      "&type=2&vcmSiId=" +
      Cache.get("VCM_INFO").vcmPlatCode
    );
  },
  imgPathVcmByPr(fileId) {
    let token = Cache.get("access_token");
    let fileIds = "";
    if (fileId && fileId.length) {
      fileIds = fileId.replace(/\#/g, "%23"); // eslint-disable-line
      fileIds = fileIds.replace(/\@/g, "%40"); // eslint-disable-line
    }
    return (
      "/bas/safeEvent/getPictureStream.json?fileId=" +
      fileIds +
      "&imageType=1&ticket=" +
      token +
      "&type=1&vcmSiId=" +
      Cache.get("VCM_INFO").vcmPlatCode
    );
  },
  /*
   *@name: 查看vcm抓拍图片
   *@param:{type} type: 2 小图 3 大图
   */
  getFacePictureStream(fileId, type = "2", width, height) {
    let token = Cache.get("access_token");
    let fileIds = fileId.replace(/\#/g, "%23"); // eslint-disable-line
    fileIds = fileIds.replace(/\@/g, "%40"); // eslint-disable-line
    let vcmSiId = Cache.get("VCM_INFO").vcmPlatCode;
    let url = `/bas/safeEvent/getFacePictureStream.json?fileId=${fileIds}&type=${type}&vcmSiId=${vcmSiId}&ticket=${token}`;
    if (width) {
      url += `&width=${width}`;
    }
    if (height) {
      url += `&height=${height}`;
    }
    return url;
  },
  //
  downFile(url) {
    let api=window.systemConfig.DOWN_FILE
    return api+'/'+url
  }
};
export default BUS;
